import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="py-24 bg-[#faf8f4] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/ed011e25a98febe20fd436117c3fe485.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f5ede0] text-[#8b5e3c] text-xs font-semibold uppercase tracking-widest mb-6">
          <i className="ri-user-add-line"></i>
          For Creators
        </div>
        <h2 className="text-5xl font-bold text-[#2c1e0f] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Are You a Creator?
        </h2>
        <p className="text-lg text-[#7a6555] mb-8 leading-relaxed">
          Join our growing directory and reach thousands of junk journal enthusiasts and snail mail lovers actively searching for products like yours.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/submit"
            className="px-8 py-4 rounded-full bg-[#8b5e3c] text-white font-semibold text-base hover:bg-[#7a5234] transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
          >
            Submit Your Information
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
          <Link
            to="/catalog"
            className="px-8 py-4 rounded-full border-2 border-[#c9a87c] text-[#8b5e3c] font-semibold text-base hover:bg-[#f5ede0] transition-colors whitespace-nowrap"
          >
            Browse the Directory
          </Link>
        </div>

        {/* Creator Showcase Strip */}
        <div className="mt-16 grid grid-cols-4 gap-3">
          {[
            { seq: "strip1", label: "Vintage Papers" },
            { seq: "strip2", label: "Washi Tapes" },
            { seq: "strip3", label: "Handmade Stamps" },
            { seq: "strip4", label: "Snail Mail Kits" },
          ].map((item) => (
            <div key={item.seq} className="rounded-xl overflow-hidden aspect-square">
              <img
                src={`https://readdy.ai/api/search-image?query=$%7BencodeURIComponent%28%60$%7Bitem.label%7D%20junk%20journal%20craft%20supplies%20flat%20lay%20warm%20cream%20tones%20aesthetic%20minimal%60%29%7D&width=200&height=200&seq=${item.seq}&orientation=squarish`}
                alt={item.label}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
